export default __webpack_public_path__ + "static/media/cashew_smoothie.206b6613.jpg";